<template>
  <div>
    <el-progress v-if="socket_key" :percentage="progress"></el-progress>
    <div class="search-wrap">
      <el-button size="mini" @click="pageChange(1)">查询</el-button>
      <el-button size="mini" @click="computeDosageNumber()">生成</el-button>
<!--      <el-button size="mini" @click="getOrderExcel()">导出分摊费用（旧方法）</el-button>-->
<!--      <el-button size="mini" @click="getSalesExcel()">导出物业费用（旧方法）</el-button>-->

      <el-button size="mini" @click="getAllExcel()">综合账单导出</el-button>
      <el-button size="mini" @click="importAllExcel()">账单校正导入[未审核前]</el-button>
      <el-button size="mini" @click="importAllExcelUpdate()">账单校正导入[已审核后]</el-button>

      <el-dropdown @command="handleCommand">
        <el-button size="mini">锁定</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batch-is_lock_1">批量调整</el-dropdown-item>
          <el-dropdown-item command="all-is_lock_1">全部调整</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown @command="handleCommand">
        <el-button size="mini">反锁定</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batch-is_lock_0">批量调整</el-dropdown-item>
          <el-dropdown-item command="all-is_lock_0">全部调整</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown @command="handleCommand">
        <el-button size="mini">反审核</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batch-is_examine_0">批量调整</el-dropdown-item>
          <el-dropdown-item command="all-is_examine_0">全部调整</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-button size="mini" @click="startFlow()">发起审批</el-button>

      <el-button type="danger" size="mini" @click="deleteOrderItem()">批量删除</el-button>
      <el-button type="danger" size="mini" @click="deleteOrder()">全部删除</el-button>
    </div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="抄表月份">
          <el-date-picker
            v-model="mainObj.read_month"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="pageChange(1)"
            placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="客户房产">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            size="mini"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="应收日期">
          <el-date-picker
            v-model="where.should_charge_date"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="pageChange(1)"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="descriptions-label-class" label="客户名称">
          <el-autocomplete
            class="w-300"
            size="mini"
            v-model="where.customer_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入姓名"
            @select="handleSelect2"
          ></el-autocomplete>
        </el-descriptions-item>

        <el-descriptions-item label="收费项目">
          <el-select size="mini" style="width: 100%" v-model="where2.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" style="width: 100%" v-model="where2.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>


<!--        <el-descriptions-item label="仪表编号">-->
<!--          <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="仪表名称">-->
<!--          <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="仪表类型">-->
<!--          <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">-->
<!--            <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--          </el-select>-->
<!--        </el-descriptions-item>-->

        <el-descriptions-item label="能耗类型">
          <el-select size="mini" style="width: 100%" v-model="where.energy" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in energy_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否锁定">
          <el-select size="mini" style="width: 100%" v-model="where.is_lock" clearable filterable placeholder="请选择" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in [{name:'未锁定',val:0},{name:'已锁定',val:1}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否审核">
          <el-select size="mini" style="width: 100%" v-model="where.is_examine" clearable filterable placeholder="请选择" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in [{name:'未审核',val:0},{name:'待审核',val:1},{name:'已审核',val:2},{name:'已驳回',val:-1}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <div class="header-tip">
        总计收费： {{formatMoney(order_count_obj.all_money,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        业主能耗： {{formatMoney(order_count_obj.money_1,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        分摊能耗 [成本价]： {{formatMoney(order_count_obj.money_3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        物业能耗 [销售价]： {{formatMoney(order_count_obj.money_2,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>
    <div>
      <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="50vh" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
        <el-table-column prop="h_name_date" label="房产" width="320" align="center" fixed></el-table-column>
        <el-table-column prop="customer_name" label="客户" width="180" align="center"></el-table-column>
        <el-table-column prop="charge_sum" label="周期" width="180" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                周期<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-startDate#endDate">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-startDate#endDate">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <span>{{scope.row.startDate}}~{{scope.row.endDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chargePay" label="应收费用" width="100" align="center"></el-table-column>
        <el-table-column prop="charge" label="收费金额" width="100" align="center"></el-table-column>
        <el-table-column prop="should_charge_date" label="应收日期" width="100" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                应收日期<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-should_charge_date">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-should_charge_date">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="xsc_LastReadDegree" label="上期读数" width="100" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                上期读数<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-xsc_LastReadDegree">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-xsc_LastReadDegree">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="xsc_CurrentReadDegree" label="本期读数" width="100" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                本期读数<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-xsc_CurrentReadDegree">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-xsc_CurrentReadDegree">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="charge_item_name" label="收费项目" width="120" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                收费项目<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-charge_item_name">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-charge_item_name">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="charge_name" label="收费标准" width="200" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                收费标准<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-charge_name">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-charge_name">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="xsc_Price" label="单价" width="100" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                单价<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-xsc_Price">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-xsc_Price">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="xsc_Amount" label="数量/用量" width="100" align="center">
          <template slot="header">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                数量/用量<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="batch-xsc_Amount">批量调整</el-dropdown-item>
                <el-dropdown-item command="all-xsc_Amount">全部调整</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="is_lock" label="锁定状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_lock===1">已锁定</span>
            <span v-else>未锁定</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_examine" label="审批状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_examine===1">审核中</span>
            <span v-else-if="scope.row.is_examine===2">已审核</span>
            <span v-else-if="scope.row.is_examine===-1">已驳回</span>
            <span v-else>待审核</span>
          </template>
        </el-table-column>

        <el-table-column label="操作 " fixed="right" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="splitOrderItem(scope.row)">拆分</el-button>
            <el-button v-if="scope.row.is_lock===0" type="danger" size="mini" icon="el-icon-edit" @click="deleteOrderItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
      <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>

    <InputBox ref="inputBoxRef" />
    <MeterOrderHouseComputeDialog ref="MeterOrderHouseComputeDialogRef" />
    <SelectCharge ref="SelectChargeRef" />
    <MeterOrderUserSplit ref="MeterOrderUserSplitRef" />

  </div>
</template>

<script>
import {Loading} from "element-ui";
import AppConfig from "../../../../../config/AppConfig";
import MeterHttp from "../../common/MeterHttp";
import moment from "moment";
import InputBox from "../meter_note/components/InputBox";
import MeterOrderHouseComputeDialog from "./components/MeterOrderHouseComputeDialog";
import SelectCharge from "./components/SelectCharge";
import MeterOrderUserSplit from "./components/MeterOrderUserSplit";

export default {
  name: "MeterUserOrderList",
  components: {MeterOrderUserSplit, SelectCharge, MeterOrderHouseComputeDialog, InputBox},
  provide() {
    return {
      where: this.where,
    }
  },
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        house_id:"",
        house_name:"",
        customer_id:"",
        customer_name:"",
        should_charge_date:"",
        energy:"",
        is_lock:"",
        is_examine:"",
      },
      where2:{
        charging_standard:'',
        chargeItem_name_id:''
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      chargeItem_name_ids:null,
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 50,
        page: 1
      },
      multipleSelection: [],
      order_count_obj:{
        all_money:0,
        money_1:0,
        money_2:0,
        money_3:0,
        all_count:0,
        count_1:0,
        count_2:0,
        count_3:0,
      },
      progress: 0,
      socket_key:null,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.getHouseChargeitemNameList();
    this.mainObj.project_id&&this.getHouseChargeList();
    this.where.should_charge_date=moment(this.mainObj.read_month).endOf('month').format("YYYY-MM-DD");
    this.pageChange(1)
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderHouse/getHouseList",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
      MeterHttp.post("MeterOrderHouse/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          that.order_count_obj=res.data;
        }
      })
    },
    computeDosageNumber(){
      const that = this;
      that.$refs.MeterOrderHouseComputeDialogRef.show(()=>{
        that.pageChange(1);
      });
      return false
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      let loadingInstance = Loading.service({ fullscreen: true });
      MeterHttp.post("MeterOrderHouse/computeHouse",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
      }, res => {
        loadingInstance.close();
        if (res.code) {
          that.pageChange(1)
        }
      })
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      // this.where.house_id=item.id||0;
      this.where.house_name=item.value;
      this.pageChange(1);
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect2(item) {
      const that = this;
      // that.where.customer_id=item.data.id||0;
      that.where.customer_name=item.data.name;
      that.pageChange(1);
    },
    reNumber(x){
      return Math.floor(x*10000)/10000
    },
    getOrderExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getOrderExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
     })
    },
    getSalesExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getSalesExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
     })
    },
    getAllExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderHouse/getMeterOrderHouseExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          window.open(res.data)
          // that.initTaskClient(res.data,()=>{
          //
          // })
        }
        that.loading = false;
      })
    },
    importAllExcel(){
      const that = this;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      that.$confirm('导入的数据将会覆盖原有（未锁定/未审核）数据，是否确定导入数据吗？').then((res) => {
        that.loading=true;
        MeterHttp.uploadFile(file=>{
          that.loading=false;
          that.importExcel(file)
        })
      })
    },
    importExcel(excel_file) {
      const that = this;
      if(!excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      that.loading=true;
      MeterHttp.post("MeterOrderHouse/importMeterOrderHouse",{
        project_id:that.mainObj.project_id,
        file:excel_file,
      },res=>{
        that.loading=false;
        if(res.code) {
          that.$message.success(res.msg||'导入成功');
          that.pageChange(1)
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
      })
    },
    importAllExcelUpdate(){
      const that = this;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      that.$confirm('导入的数据将会覆盖已审核数据（能耗/账单），但过程也会被记录，是否确定导入数据吗？').then((res) => {
        that.loading=true;
        MeterHttp.uploadFile(file=>{
          that.loading=false;
          that.importExcelUpdate(file)
        })
      })
    },
    importExcelUpdate(excel_file) {
      const that = this;
      if(!excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      that.loading=true;
      MeterHttp.post("MeterOrderHouse/importMeterOrderHouseUpdate",{
        project_id:that.mainObj.project_id,
        file:excel_file,
      },res=>{
        that.loading=false;
        if(res.code) {
          that.$message.success(res.msg||'导入成功');
          that.pageChange(1)
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
      })
    },
    startFlow(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderHouse/addBatchNumber",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
      }, res => {
        that.loading = false;
        if (res.code) {
          let timeValue=(new Date()).getTime()
          ERP.navigateTo(`/flow/FlowView?sheet_id=161&master_id=128&batch_number=${res.data}&timeValue=${timeValue}`)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    initEvent(socket_key,callback){
      const that = this;
      that.socket_key = socket_key;
      MeterHttp.post("MeterOrder/getSocketKey",{socket_key: socket_key}, res => {
        console.log(res)
        if (res.code==1) {
          that.progress = res.progress||0;
          setTimeout(() => {
            that.initEvent(socket_key,callback)
          }, 2000)
        }else {
          that.socket_key = null;
          that.$message.success('生成成功');
          that.pageChange(1)
          callback && callback()
        }
      })
    },
    initTaskClient(socket_key,callback){
      const that = this;
      that.socket_key = socket_key;
      MeterHttp.post("TaskClient/getTask",{socket_key: socket_key}, res => {
        if (res.code==1) {
          that.progress = res.data.progress||0;
          if(res.data.progress==100){
            that.$message.success(res.msg || "数据异常");
            that.socket_key = null;
            console.log(res.data)
            window.open(res.data.filepath)
            callback && callback()
          }else{
            setTimeout(() => {
              that.initTaskClient(socket_key,callback)
            }, 2000)
          }

        }else {
          that.socket_key = null;
          that.$message.error(res.msg || "数据异常");
          callback && callback()
        }
      })
    },
    handleCommand(command){
      const that = this;
      let command_arr = command.split('-');
      let command_type = command_arr[0];
      let command_field = command_arr[1];

      console.log(command_type,command_field)

      switch (command_field){
        case 'startDate#endDate':
          that.setOrderKeyValue('startDate#endDate',command_type);
          break;
        case 'should_charge_date':
          that.setOrderKeyValue('should_charge_date',command_type);
          break;
        case 'xsc_LastReadDegree':
          that.setOrderKeyValue('xsc_LastReadDegree',command_type);
          break;
        case 'xsc_CurrentReadDegree':
          that.setOrderKeyValue('xsc_CurrentReadDegree',command_type);
          break;
        case 'xsc_Price':
          that.setOrderKeyValue('xsc_Price',command_type);
          break;
        case 'xsc_Amount':
          that.setOrderKeyValue('xsc_Amount',command_type);
          break;
        case 'is_lock_0':
          that.setOrderKeyValue('is_lock',command_type,0);
          break;
        case 'is_lock_1':
          that.setOrderKeyValue('is_lock',command_type,1);
          break;
        case 'is_examine_0':
          that.setOrderKeyValue('is_examine',command_type,0);
          break;
        case 'is_examine_1':
          that.setOrderKeyValue('is_examine',command_type,1);
          break;
        case 'charge_item_name':
          that.setOrderKeyValue('charge_name',command_type);
          break;
        case 'charge_name':
          that.setOrderKeyValue('charge_name',command_type);
          break;
        default:
          break;
      }
    },
    setOrderKeyValue(field,command_type,command_value=null){
      const that = this;
      if(command_type==='batch'&&this.user_order_ids.length===0){
        that.$message.error('请选择账单');
        return false;
      }
      switch (field){
        case'startDate#endDate':
          that.$refs.inputBoxRef.show('daterange',value=>{
            if(!value){
              that.$message.error('请选择日期');
              return false;
            }
            let _field = field.split('#');
            //时间转化为11位时间戳
            let timeStamp1 = moment(value[0]).valueOf().toString().substr(0,10); //截取前10位
            let timeStamp2 = moment(value[1]).valueOf().toString().substr(0,10); //截取前10位
            command_type==='batch'&&that._setOrderKeyValue(_field[0],timeStamp1);
            command_type==='all'&&that.setOrderAllKeyValue(_field[0],timeStamp1);
            command_type==='batch'&&that._setOrderKeyValue(_field[1],timeStamp2);
            command_type==='all'&&that.setOrderAllKeyValue(_field[1],timeStamp2);
          });
          break;
        case'should_charge_date':
          that.$refs.inputBoxRef.show('date',value=>{
            if(!value){
              that.$message.error('请选择日期');
              return false;
            }
            //时间转化为11位时间戳
            let timeStamp = moment(value).valueOf().toString().substr(0,10); //截取前10位
            command_type==='batch'&&that._setOrderKeyValue(field,timeStamp);
            command_type==='all'&&that.setOrderAllKeyValue(field,timeStamp);
          });
          break;
        case 'xsc_LastReadDegree':
          that.$refs.inputBoxRef.show('number',value=>{
            if(!value){
              that.$message.error('请输入数值');
              return false;
            }
            command_type==='batch'&&that._setOrderKeyValue(field,value);
            command_type==='all'&&that.setOrderAllKeyValue(field,value);
          });
          break;
        case 'xsc_CurrentReadDegree':
          that.$refs.inputBoxRef.show('number',value=>{
            if(!value){
              that.$message.error('请输入数值');
              return false;
            }
            command_type==='batch'&&that._setOrderKeyValue(field,value);
            command_type==='all'&&that.setOrderAllKeyValue(field,value);
          });
          break;
        case 'xsc_Price':
          that.$refs.inputBoxRef.show('number',value=>{
            if(!value){
              that.$message.error('请输入数值');
              return false;
            }
            command_type==='batch'&&that._setOrderKeyValue(field,value);
            command_type==='all'&&that.setOrderAllKeyValue(field,value);
          });
          break;
        case 'xsc_Amount':
          that.$refs.inputBoxRef.show('number',value=>{
            if(!value){
              that.$message.error('请输入数值');
              return false;
            }
            command_type==='batch'&&that._setOrderKeyValue(field,value);
            command_type==='all'&&that.setOrderAllKeyValue(field,value);
          });
          break;
        case 'is_lock':
          command_type==='batch'&&that._setOrderKeyValue(field,command_value);
          command_type==='all'&&that.setOrderAllKeyValue(field,command_value);
          break;
        case 'is_examine':
          command_type==='batch'&&that._setOrderKeyValue(field,command_value);
          command_type==='all'&&that.setOrderAllKeyValue(field,command_value);
          break;
        case 'charge_name':
          that.$refs.SelectChargeRef.show(ret=>{
            command_type==='batch'&&that._setOrderKeyValue(field,ret.charging_standard);
            command_type==='all'&&that.setOrderAllKeyValue(field,ret.charging_standard);
          });
          break;

        default:
          break;
      }

    },
    _setOrderKeyValue(field,value){
      const that = this;
      MeterHttp.post("MeterOrderHouse/setOrderKeyValue",{
        project_id:that.mainObj.project_id,
        order_ids:that.user_order_ids.join(','),
        field:field,
        value:value
      }, res => {
        if (res.code) {
          that.$message.success('设置成功');
          that.pageChange(1)
        }
      })
    },
    setOrderAllKeyValue(field,value) {
      const that = this;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderHouse/setOrderAllKeyValue",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        field:field,
        value:value
      }, res => {
        if (res.code) {
          that.$message.success('设置成功');
          that.pageChange(1)
        }
      })
    },
    deleteOrder(){
      const that = this;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      that.$confirm('确认删除该账单吗？').then(() => {
        MeterHttp.post("MeterOrderHouse/deleteOrder", {
          project_id: that.mainObj.project_id,
          ...where,
          ...that.where2,
          user_type: (that.$route.query.type || 0)
        }, res => {
          if (res.code) {
            that.$message.success('设置成功');
            that.pageChange(1)
          } else {
            that.$message.error(res.msg)
          }
        })
      });
    },
    deleteOrderItem(row=null){
      const that = this;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      if(row){
        that.multipleSelection = [row];
      }
      if(that.multipleSelection.length===0){
        that.$message.error('请选择账单');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      that.$confirm('确认删除该账单吗？').then(() => {
        MeterHttp.post("MeterOrderHouse/deleteOrder", {
          project_id: that.mainObj.project_id,
          ...where,
          ...that.where2,
          user_type: (that.$route.query.type || 0),
          order_ids: that.multipleSelection.map(ret => ret.id).join(','),
        }, res => {
          if (res.code) {
            that.$message.success('设置成功');
            that.pageChange(1)
          } else {
            that.$message.error(res.msg)
          }
        })
      });
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where2.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where2.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    splitOrderItem(row){
      const that = this;
      ERP.postRequest({
        url:"admin/UserOrderSplit/CheckOrder",
        data:{
          pindex_id: row.pindex_id,
          house_id: row.house_id,
          charge_id: row.charge_id,
          startDate: row.startDate,
          endDate: row.endDate,
          xsc_ChargeItemID_id: row.xsc_ChargeItemID_id
        }
      },res=>{
        if (res.code===200) {
          that.$refs.MeterOrderUserSplitRef.show(row,()=>{
            that.getList();
          })
        }else {
          that.$message.error(res.message||"异常")
        }
      })
    },
  },
  computed:{
    all_money(){
      let m_arr=this.pageData.list.map(ret=>ret.charge_sum*1)
      return m_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },
    user_order_ids(){
      return this.multipleSelection.map(ret=>ret.id)
    }
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    "mainObj.read_month":function (n,o) {
      if(n){
        //设置抄表月的最后一天为应收日期
        this.where.should_charge_date=moment(n).endOf('month').format('YYYY-MM-DD');
      }else {
        this.where.should_charge_date = '';
      }
    },
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.where2.charging_standard="";
        this.getHouseChargeList();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common.scss";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterUserOrderList.vue